class FooterAccordion {
  constructor(footer) {
    footer.dataset.accordionInitialized = 'true';
    this.menus = footer.querySelectorAll('.footer-block__menu-accordion');
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.update = this.update.bind(this);

    this.update(this.mobileQuery);
    this.mobileQuery.addEventListener('change', this.update);
  }

  update(event) {
    this.menus.forEach((menu) => {
      menu.open = !event.matches;
    });
  }
}

const initializeFooterAccordion = (container = document) => {
  container.querySelectorAll('.footer:not([data-accordion-initialized])').forEach((footer) => new FooterAccordion(footer));
};

initializeFooterAccordion();

document.addEventListener('shopify:section:load', (event) => {
  initializeFooterAccordion(event.target);
});
